import Amplify from '@aws-amplify/core'
import Auth from '@aws-amplify/auth'
import store from '../../store/store'
import Vue from 'vue'
import swal from 'sweetalert2'
import i18n from '../../locales/i18n'

export function startRefreshTokenWorker () {
  if (window.__cognitoRefreshTokenWorker) {
    return
  }

  try {
    setTimeout(() => {
      window.__cognitoRefreshTokenWorker = new Worker('/js/cognitoTokenRefresh.js')

      window.__cognitoRefreshTokenWorker.addEventListener('message', (e) => {
        const data = JSON.parse(e.data)
        console.warn('Worker falou mandou isso', e.data)

        if (data.error) {
          store.dispatch('logout')
          return
        }

        store.commit('cognitoInfo', {
          accessToken: 'Bearer ' + data.id_token
        })
      })

      window.__cognitoRefreshTokenWorker.postMessage(JSON.stringify(
        store.state.accessData.cognitoInfo
      ))
    }, 300)
  } catch (e) {
    console.warn('Failed to start refresh token worker. Probably this session will only last 1 hour.')
    console.error(e)
  }
}

export async function SolarSSOLogin (from, to, next) {
  const authToken = from.query.token
  if (authToken) {
    store.commit('solarInfo', {
      authorization: 'Bearer ' + authToken
    })
    try {
      await store.dispatch('coletor/criarColetorSSO')
      window.history.replaceState(null, '', window.location.pathname)
    } catch (e) {
      await swal({ type: 'info', text: e.data.error || i18n.t('componentes.register.cognito.modalDeErroComum.texto') })
      window.location.href = window.location.origin + window.location.pathname
    }
  }
}

export async function SAMLLoginUrl () {
  store.commit('executingSAMLLogin', true)

  const samelInfos = (/\?user_pool_id(?:=|%3D)(.*)\?client_id(?:=|%3D)(.*)\?domain(?:=|%3D)(.*)&code(?:=|%3D)(.*)#\//).exec(window.location.href)
  const infos = {userPoolId: samelInfos[1], clientId: samelInfos[2], domain: samelInfos[3], code: samelInfos[4]}

  const tokenAPI = `https://${infos.domain}.auth.us-east-1.amazoncognito.com/oauth2/token`

  let url = window.location.origin + window.location.pathname
  url = url[url.length - 1] === '/' ? url.slice(0, url.length - 1) : url

  if (url.includes('/index.html')) {
    url = url.replace('/index.html', '')
  }

  const tokens = await Vue.http.post(
    tokenAPI,
    {
      grant_type: 'authorization_code',
      client_id: infos.clientId,
      // redirect has to be the same as in cognito dashboard > App clients settings > callback urls
      redirect_uri: `${url}?user_pool_id=${infos.userPoolId}?client_id=${infos.clientId}?domain=${infos.domain}`,
      code: infos.code
    },
    {emulateJSON: true}
  )

  store.commit('cognitoInfo', {
    accessToken: 'Bearer ' + tokens.body.id_token,
    userPoolId: infos.userPoolId,
    userPoolWebClientId: infos.clientId,
    refreshToken: tokens.body.refresh_token,
    isSamlLogin: true,
    tokenAPI
  })

  try {
    await store.dispatch('coletor/criarColetorSSO')
    window.history.replaceState(null, '', window.location.pathname)
  } catch (e) {
    await swal({ type: 'info', text: e.data.error || i18n.t('componentes.register.cognito.modalDeErroComum.texto') })
    window.location.href = window.location.origin + window.location.pathname
    store.commit('executingSAMLLogin', false)
  }
}

export function configureCongito ({ userPoolId, userPoolWebClientId }) {
  Amplify.configure({
    Auth: {
      userPoolId,
      region: 'us-east-1',
      identityPoolRegion: 'us-east-1',
      userPoolWebClientId,
      storage: window.localStorage,
      authenticationFlowType: 'USER_SRP_AUTH'
    }
  })
}

// TODO REMOVE THIS
window.Auth = Auth
